module.exports = __webpack_public_path__ + "static/media/neo_Logo_glow.3413e299.png";